import axios from "axios"
import { docCookies } from "../utils/docCookies"
import qs from "qs"

const axiosConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Authorization: docCookies.getItem("auth_token")
      ? "Token token=" + docCookies.getItem("auth_token")
      : "",
    "X-Api-Key": process.env.REACT_APP_X_API_KEY
  }
}

export const axiosInstance = axios.create(axiosConfig)

export class ApiHelper {
  constructor() {}

  //
  // USER
  //
  static getUser() {
    let url = "users/me"
    return axiosInstance.get(url)
  }

  static checkEmail(email) {
    return axiosInstance.get(`sessions`, { params: { email } })
  }

  static login(data, query_data) {
    let url = "login"

    // Axios headers for when logging out, we need to reset the key
    axiosInstance.defaults.headers["X-Api-Key"] =
      process.env.REACT_APP_X_API_KEY

    // credentials
    let login_data = { ...data, ...query_data }
    return axiosInstance.post(url, login_data)
  }

  static createUser(data, query_data) {
    let url = "users"

    // Axios headers for when logging out, we need to reset the key
    axiosInstance.defaults.headers["X-Api-Key"] =
      process.env.REACT_APP_X_API_KEY

    // Set confirmation
    data.password_confirmation = data.password

    // Send post
    let user_data = { user: { ...data, ...query_data } }
    return axiosInstance.post(url, user_data)
  }
  static updateUser(data) {
    let url = "users/me"
    let user_data = { user: { ...data } }
    return axiosInstance.put(url, user_data)
  }

  //
  // ACCOUNTANT GROUP
  //
  static getAccountantGroup() {
    let url = "accountant_groups/current"
    return axiosInstance.get(url)
  }
  static updateAccountantGroup(data) {
    // Remove photo key as we use photo_attributes to upload
    delete data.photo

    // Loop over data and create form data with file
    var form_data = new FormData()
    for (var key in data) {
      var item = data[key]

      if (key == "photo_attributes") {
        var blob = new Blob([data.photo_attributes.image], {
          type: data.photo_attributes.image.type
        })
        var fileOfBlob = new File([blob], data.photo_attributes.image.name)
        form_data.append(
          "accountant_group[photo_attributes][image]",
          fileOfBlob
        )
      } else {
        form_data.append("accountant_group[" + key + "]", item)
      }
    }

    let url = "accountant_groups/first"
    return axiosInstance.put(url, form_data)
  }
  static createClientInvites(data) {
    data.type = "InviteClient"

    let url = "invites/create_multiple"
    return axiosInstance.post(url, data)
  }
  static getClient(token_id, data) {
    let url = "accountant_groups/clients/" + token_id
    return axiosInstance.get(url, { params: data })
  }
  static sendDataExport(token_id, data) {
    let url = "accountant_groups/clients/" + token_id + "/export_data"
    return axiosInstance.post(url, data)
  }

  //
  // TRIPS
  //

  static createTrip(data) {
    if (!data.miles) throw Error("no miles", data)
    var form_data = new FormData()
    for (var key in data) {
      var item = data[key]

      if (key == "photo_attributes") {
        var blob = new Blob([data.photo_attributes], {
          type: data.photo_attributes.type
        })
        var fileOfBlob = new File([blob], data.photo_attributes.name)
        form_data.append("trip[photo_attributes][image]", fileOfBlob)
      } else if (key == "locations") {
        data.locations.forEach(val => {
          form_data.append(`trip[locations][]`, String(val))
        })
      } else {
        // avoid nulls and assign the rest
        // (item !== null) && form_data.append("trip["+key+"]", item);
        form_data.append("trip[" + key + "]", item)
        // except start/end_place_token
        // (key=='start_place_token' || key=='end_place_token') && form_data.append("trip["+key+"]", item);
      }
    }

    return axiosInstance.post("/trips", form_data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  static getTrips(data) {
    // NOTE null values do not render as params
    return axiosInstance.get("/trips", { params: { ...data, limit: 10 } })
  }
  static getTrip(token_id) {
    return axiosInstance.get(`/trips/${token_id}`)
  }
  static updateTrips(data) {
    return axiosInstance.put("/trip_batches/update", data)
  }
  static updateTrip(data) {
    // // Loop over data and create form data with file
    var form_data = new FormData()
    for (var key in data) {
      var item = data[key]

      if (key == "photo_attributes") {
        if (data.photo_attributes == null) {
          form_data.append("trip[photo_attributes][_destroy]", true)
        } else {
          var blob = new Blob([data.photo_attributes], {
            type: data.photo_attributes.type
          })
          var fileOfBlob = new File([blob], data.photo_attributes.name)
          form_data.append("trip[photo_attributes][image]", fileOfBlob)
        }
      } else if (key == "locations") {
        data.locations.forEach(val => {
          form_data.append(`trip[locations][]`, String(val))
        })
      } else {
        // // // avoid nulls and assign the rest
        // (item !== null) && form_data.append("trip["+key+"]", item);
        // // except start/end_place_token
        // (key=='start_place_token' || key=='end_place_token') && form_data.append("trip["+key+"]", item);
        form_data.append("trip[" + key + "]", item)
      }
    }

    return axiosInstance.put(`/trips/${data.token_id}`, form_data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  static mergeTrips(data) {
    return axiosInstance.post(`/merge_trips/`, data)
  }
  static undoTripMerge(token_id) {
    return axiosInstance.delete(`/merge_trips/${token_id}`)
  }
  static deleteTrip(token_id) {
    return axiosInstance.delete(`/trips/${token_id}`)
  }
  static deleteTrips(data) {
    return axiosInstance.delete(
      "/trip_batches/delete?" + qs.stringify(data, { arrayFormat: "brackets" })
    )
  }

  //
  // TRANSACTIONS
  //
  static createTransaction(data) {
    var form_data = new FormData()
    for (var key in data) {
      var item = data[key]

      if (key == "photo_attributes") {
        var blob = new Blob([data.photo_attributes], {
          type: data.photo_attributes.type
        })
        var fileOfBlob = new File([blob], data.photo_attributes.name)
        form_data.append("transaction[photo_attributes][image]", fileOfBlob)
      } else {
        // avoid nulls and assign the rest
        item !== null && form_data.append("transaction[" + key + "]", item)
      }
    }

    return axiosInstance.post("/transactions", form_data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  static getTransactions(data) {
    return axiosInstance.get("/transactions", { params: data })
  }
  static getTransaction(token_id) {
    return axiosInstance.get(`/transactions/${token_id}`)
  }
  static updateTransactions(data) {
    return axiosInstance.put("/transaction_batches/update", data)
  }
  static updateTransaction(data) {
    // // Loop over data and create form data with file
    var form_data = new FormData()
    for (var key in data) {
      var item = data[key]

      if (key == "photo_attributes") {
        if (data.photo_attributes == null) {
          form_data.append("transaction[photo_attributes][_destroy]", true)
        } else {
          var blob = new Blob([data.photo_attributes], {
            type: data.photo_attributes.type
          })
          var fileOfBlob = new File([blob], data.photo_attributes.name)
          form_data.append("transaction[photo_attributes][image]", fileOfBlob)
        }
      } else {
        // avoid nulls and assign the rest
        item !== null && form_data.append("transaction[" + key + "]", item)
      }
    }

    return axiosInstance.put(`/transactions/${data.token_id}`, form_data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  static deleteTransaction(token_id) {
    return axiosInstance.delete(`/transactions/${token_id}`)
  }
  static deleteTransactions(data) {
    return axiosInstance.delete(
      "/transaction_batches/delete?" +
        qs.stringify(data, { arrayFormat: "brackets" })
    )
  }

  //
  // TOTALS
  //
  static getTotals(data) {
    return axiosInstance.get("/users/me/totals", { params: data })
  }

  // ACCOUNT TRIPS
  static listFavoriteTrips() {
    return axiosInstance.get("/favorite_trips")
  }

  static addFavoriteTrip(data) {
    return axiosInstance.post("/favorite_trips", data)
  }

  static updateFavoriteTrip(data) {
    return axiosInstance.put(`/favorite_trips/${data.token_id}`, data)
  }

  static deleteFavoriteTrip(id) {
    return axiosInstance.delete(`/favorite_trips/${id}`)
  }

  // FAVORITE PLACES
  static listFavoritePlaces() {
    return axiosInstance.get("/places")
  }

  static createFavoritePlace(data) {
    return axiosInstance.post("/places", data)
  }

  static updateFavoritePlace(data) {
    return axiosInstance.put(`/places/${data.token_id}`, data)
  }

  static deleteFavoritePlace(id) {
    return axiosInstance.delete(`/places/${id}`)
  }

  // VEHICLES
  static listVehicles() {
    return axiosInstance.get("/vehicles")
  }

  static createVehicle(data) {
    return axiosInstance.post("/vehicles", data)
  }

  static updateVehicle(data) {
    return axiosInstance.put(`/vehicles/${data.token_id}`, data)
  }

  static deleteVehicle(token_id) {
    return axiosInstance.delete(`/vehicles/${token_id}`)
  }

  // ACCOUNT DATA EXPORT
  static dataExport(data) {
    return axiosInstance.post("/data_exports", data)
  }

  static getDataExports() {
    return axiosInstance.get("/data_exports")
  }

  //
  // ENTERPRISE GROUP
  //
  static getEnterpriseGroup() {
    let url = "enterprise_groups/current"
    return axiosInstance.get(url)
  }
  static getMember(token_id, data) {
    let url = "enterprise_groups/members/" + token_id
    return axiosInstance.get(url, { params: data })
  }
  static sendDataExportEnterprise(token_id, data) {
    let url = "enterprise_groups/members/" + token_id + "/export_data"
    return axiosInstance.post(url, data)
  }

  static createMemberInvites(data) {
    data.type = "InviteMember"
    let url = "enterprise_groups/members"
    return axiosInstance.post(url, data)
  }

  static removeEnterpriseMember(token_id) {
    let url = "enterprise_groups/members/" + token_id
    return axiosInstance.delete(url)
  }

  //
  // SUBSCRIPTION
  //
  static createSubscription(
    stripe_card_token,
    product_identifier,
    coupon,
    quantity,
    sourceType,
    accountId
  ) {
    let url = "subscriptions"
    let data = {
      subscription: {
        stripe_card_token: stripe_card_token,
        product_identifier: product_identifier,
        coupon: coupon,
        quantity: quantity,
        source_type: sourceType,
        account_id: accountId
      }
    }
    return axiosInstance.post(url, data)
  }
  static updateSubscription(product_identifier, coupon, quantity) {
    let url = "subscriptions/current"
    let data = {
      subscription: {
        product_identifier: product_identifier,
        coupon: coupon,
        quantity: quantity
      }
    }
    return axiosInstance.put(url, data)
  }

  static updateCard(
    stripe_card_token,
    product_identifier,
    coupon,
    quantity,
    sourceType,
    accountId
  ) {
    let url = "subscriptions/update_customer"
    let data = {
      subscription: {
        stripe_card_token: stripe_card_token,
        product_identifier: product_identifier,
        coupon: coupon,
        quantity: quantity,
        source_type: sourceType,
        account_id: accountId
      }
    }
    return axiosInstance.post(url, data)
  }

  static cancelSubscription(password) {
    let url = "subscriptions/cancel_subscription"
    let data = { verify_password: password }
    return axiosInstance.post(url, data)
  }

  static reactivateSubscription() {
    let url = "subscriptions/reactivate_subscription"
    let data = {}
    return axiosInstance.post(url, data)
  }

  static checkCoupon(coupon) {
    let url = "subscriptions/check_coupon"
    let data = { coupon: coupon }
    return axiosInstance.post(url, data)
  }
  static getPlans() {
    return axiosInstance.get("subscriptions/me/plans")
  }
  static getInvoices(starting_after) {
    return axiosInstance.get("subscriptions/current/invoices", {
      params: { starting_after } //param gets ignored if null
    })
  }

  //
  // INVITES
  //
  // data : {
  //     "email": "managerEmail@gmail.com",
  //     "type": "InviteManager"
  // }
  static createInvite(data) {
    let url = "invites"
    return axiosInstance.post(url, data)
  }

  //
  // PLAID BANK CARD INSTITUTIONS
  //
  static createInstitutionUser(public_token, metadata, import_history) {
    let url = "institution_users"

    let data = {
      public_token,
      institution_id: metadata.institution.institution_id,
      import_history
    }
    return axiosInstance.post(url, data)
  }

  static updateInstitutionAccount(token_id, excluded) {
    let url = `institution_accounts/${token_id}`

    let data = {
      institution_account: {
        excluded
      }
    }
    return axiosInstance.put(url, data)
  }

  static unlinkInstitutionUser(token_id) {
    return axiosInstance.delete(`institution_users/${token_id}`)
  }

  static updateLogin(token_id) {
    return axiosInstance.post(`institution_users/${token_id}/public_token`)
  }

  static refreshInstitution() {
    return axiosInstance.get(`institution_users/sync`)
  }

  static importTxnStatus() {
    return axiosInstance.get(`institution_users/importing_status`)
  }

  //

  // FAVORITE TXNS
  //
  static listFavoriteTransactions() {
    return axiosInstance.get(`favorite_transactions/`)
  }
  static createFavoriteTransaction(rules_attributes, rule_actions_attributes) {
    return axiosInstance.post("favorite_transactions", {
      favorite_transaction: {
        scope: "transactions",
        rules_attributes,
        rule_actions_attributes
      }
    })
  }

  static showFavoriteTransaction(tokenId) {
    return axiosInstance.get(`favorite_transactions/${tokenId}`)
  }

  static destroyFavoriteTransaction(tokenId) {
    return axiosInstance.delete(`favorite_transactions/${tokenId}`)
  }

  static updateFavoriteTransaction(tokenId, data) {
    return axiosInstance.put(`favorite_transactions/${tokenId}`, data)
  }

  // FRESHBOOKS
  //
  static listFreshbooksAccounts() {
    return axiosInstance.get(`freshbooks_accounts`)
  }

  static showFreshbooksAccount(tokenId) {
    return axiosInstance.get(`freshbooks_accounts/${tokenId}`)
  }
  static createFreshbooksAccount(data) {
    return axiosInstance.post(`freshbooks_accounts`, data)
  }

  static updateFreshbooksAccount(tokenId, data) {
    return axiosInstance.put(`freshbooks_accounts/${tokenId}`, data)
  }

  static deleteFreshbooksAccount(tokenId) {
    return axiosInstance.delete(`freshbooks_accounts/${tokenId}`)
  }

  // XERO
  //
  static listXeroAccounts() {
    return axiosInstance.get(`xero_accounts`)
  }

  static showXeroAccount(tokenId) {
    return axiosInstance.get(`xero_accounts/${tokenId}`)
  }
  static createXeroAccount(data) {
    return axiosInstance.post(`xero_accounts`, data)
  }

  static updateXeroAccount(tokenId, data) {
    return axiosInstance.put(`xero_accounts/${tokenId}`, data)
  }

  static deleteXeroAccount(tokenId) {
    return axiosInstance.delete(`xero_accounts/${tokenId}`)
  }
}



// WEBPACK FOOTER //
// ./src/utils/ApiHelper.js